import React, { useEffect, useState } from "react";
import LogInForm from "./LogInForm";

const LoginHome = () => {
  const [inputFocus, setInputFocus] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = () => {
    setInputFocus(false);
  };

  return (
    <div
      onClick={handleClick}
      className="login-home position-relative overflow-hidden d-flex align-items-center "
      style={{
        minHeight: "100vh",
      }}
    >
      {/* Background */}
      <div className="login-bg" />
      {/* Decorative Glow - Top Left */}
      <div className="login-glow login-glow-left" />
      {/* Decorative Glow - Top Right */}
      <div className="login-glow login-glow-right" />
      {/* Decorative Grid */}
      <div className="login-grid" />
      {/* Main Content */}
      <div
        className="container-fluid d-flex align-items-center justify-content-center position-absolute top-50 start-50 translate-middle"
        style={{
          width: "100%",
          minHeight: "100vh",
          zIndex: 10,
          paddingTop: "20px",
          paddingBottom: "40px",
        }}
      >
        <div
          className="w-100 d-flex flex-column align-items-center  "
          style={{
            maxWidth: "700px",
          }}
        >
          {/* Small Brand Label */}
          <div
            className="login-brand mb-3 "
            style={{
              opacity: 0.95,
            }}
          >
            <span className="brand-line" />
            <b>
              <span style={{ fontSize: "13px" }}>RAIL-SETU</span>
            </b>
            <span className="brand-line" />
          </div>

          {/* Login Form */}
          <div
            className={`d-flex justify-content-center align-items-center w-100 border border-red ${
              isMobile ? "mt-1" : ""
            }`}
            style={{
              zIndex: 20,
            }}
          >
            <div className="login-form-wrapper ">
              <LogInForm
                inputFocus={inputFocus}
                setInputFocus={setInputFocus}
              />
            </div>
          </div>

          {/* Bottom Caption */}
          <div
            className="text-center mt-3"
            style={{
              fontSize: "11px",
              color: "#64748b",
              letterSpacing: "0.4px",
              zIndex: 20,
            }}
          >
            Railway Operations • Monitoring • Management
          </div>
        </div>
      </div>
      {/* Bottom Waves */}
      <div className="login-waves position-absolute w-100 h-100">
        <div
          className="position-absolute"
          style={{
            left: "150px",
            // top: "20%",
          }}
        >
          <svg
            width="300"
            height="300"
            viewBox="0 0 300 300"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="leftCircleGradient"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="100%"
              >
                <stop offset="0%" stopColor="#08734533" />
                <stop offset="50%" stopColor="#0a57bb50" />
                <stop offset="100%" stopColor="#063c8731" />
              </linearGradient>
            </defs>

            <circle cx="150" cy="150" r="130" fill="url(#leftCircleGradient)" />
          </svg>
        </div>{" "}
        <div
          className="position-absolute"
          style={{
            right: "150px",
            top: "20%",
          }}
        >
          <svg
            width="200"
            height="300"
            viewBox="0 0 300 300"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="leftCircleGradient"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="100%"
              >
                <stop offset="0%" stopColor="#08734533" />
                <stop offset="50%" stopColor="#0a57bb50" />
                <stop offset="100%" stopColor="#063c8731" />
              </linearGradient>
            </defs>

            <circle cx="150" cy="150" r="130" fill="url(#leftCircleGradient)" />
          </svg>
        </div>
      </div>
      (
      <div className="login-waves position-absolute bottom-0 start-0 w-100">
        {/* Back Wave */}
        <div className="position-absolute bottom-0 start-50 translate-middle-x w-100">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 300"
            preserveAspectRatio="none"
            width="100%"
            height="300"
          >
            <defs>
              <linearGradient
                id="backWaveGradient"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="100%"
              >
                <stop offset="0%" stopColor="#08734533" />
                <stop offset="50%" stopColor="#0a57bb50" />
                <stop offset="100%" stopColor="#063c8731" />
              </linearGradient>
            </defs>

            <path
              fill="url(#backWaveGradient)"
              d="M0,320L18.5,298.7C36.9,277,74,235,111,181.3C147.7,128,185,64,222,37.3C258.5,11,295,21,332,48C369.2,75,406,117,443,117.3C480,117,517,75,554,58.7C590.8,43,628,53,665,96C701.5,139,738,213,775,213.3C812.3,213,849,139,886,133.3C923.1,128,960,192,997,229.3C1033.8,267,1071,277,1108,234.7C1144.6,192,1182,96,1218,80C1255.4,64,1292,128,1329,149.3C1366.2,171,1403,149,1422,138.7L1440,128L1440,320L0,320Z"
            />
          </svg>
        </div>

        {/* Front Wave */}
        <div className="position-absolute bottom-0 start-50 translate-middle-x w-100">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 300"
            preserveAspectRatio="none"
            width="100%"
            height="300"
          >
            <defs>
              <linearGradient
                id="frontWaveGradient"
                x1="100%"
                y1="0%"
                x2="0%"
                y2="100%"
              >
                <stop offset="0%" stopColor="#063c8756" />
                <stop offset="50%" stopColor="#0a57bb5d" />
                <stop offset="100%" stopColor="#08734554" />
              </linearGradient>
            </defs>

            <path
              fill="url(#frontWaveGradient)"
              d="M0,256L10.4,266.7C20.9,277,42,299,63,261.3C83.5,224,104,128,125,96C146.1,64,167,96,188,122.7C208.7,149,230,171,250,170.7C271.3,171,292,149,313,117.3C333.9,85,355,43,376,53.3C396.5,64,417,128,438,154.7C459.1,181,480,171,501,160C521.7,149,543,139,563,128C584.3,117,605,107,626,138.7C647,171,668,245,689,282.7C709.6,320,730,320,751,298.7C772.2,277,793,235,814,208C834.8,181,856,171,877,176C897.4,181,918,203,939,218.7C960,235,981,245,1002,213.3C1022.6,181,1043,107,1064,74.7C1085.2,43,1106,53,1127,80C1147.8,107,1169,149,1190,165.3C1210.4,181,1231,171,1252,149.3C1273,128,1294,96,1315,101.3C1335.7,107,1357,149,1377,170.7C1398.3,192,1419,192,1430,192L1440,192L1440,320L0,320Z"
            />
          </svg>
        </div>
      </div>
      ){/* Footer */}
      <div
        className="position-absolute bottom-0 start-50 translate-middle-x text-center"
        style={{
          zIndex: 30,
          bottom: "12px",
          fontSize: "10px",
          color: "#64748b",
          letterSpacing: "0.5px",
        }}
      >
        © Rail-Setu
      </div>
      <style>
        {`
          .login-home {
            background: #f5f8fc;
          }

          /* Main background */
          .login-bg {
            position: absolute;
            inset: 0;
            background:
              radial-gradient(
                circle at 20% 15%,
                rgba(10, 87, 187, 0.09),
                transparent 30%
              ),
              radial-gradient(
                circle at 82% 18%,
                rgba(8, 115, 68, 0.08),
                transparent 28%
              ),
              linear-gradient(
                135deg,
                #f8fbff 0%,
                #eef5fc 48%,
                #e9f1f9 100%
              );
            z-index: 0;
          }

          /* Soft decorative glows */
          .login-glow {
            position: absolute;
            width: 320px;
            height: 320px;
            border-radius: 50%;
            filter: blur(80px);
            pointer-events: none;
            z-index: 1;
          }

          .login-glow-left {
            top: -150px;
            left: -100px;
            background: rgba(6, 59, 135, 0.12);
          }

          .login-glow-right {
            top: -130px;
            right: -100px;
            background: rgba(8, 115, 68, 0.10);
          }

          /* Very subtle grid */
          .login-grid {
            position: absolute;
            inset: 0;
            z-index: 2;
            pointer-events: none;
            opacity: 0.35;

            background-image:
              linear-gradient(
                rgba(6, 59, 135, 0.025) 1px,
                transparent 1px
              ),
              linear-gradient(
                90deg,
                rgba(6, 59, 135, 0.025) 1px,
                transparent 1px
              );

            background-size: 40px 40px;

            mask-image: linear-gradient(
              to bottom,
              black 0%,
              transparent 70%
            );
          }

          /* Brand */
          .login-brand {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;

            font-size: 12px;
            font-weight: 700;
            letter-spacing: 3px;

            color: #063b87;
          }

          .brand-line {
            width: 30px;
            height: 1px;
            background: linear-gradient(
              90deg,
              transparent,
              #0a57bb
            );
          }

          .brand-line:last-child {
            background: linear-gradient(
              90deg,
              #087344,
              transparent
            );
          }

          /* Form depth WITHOUT changing LogInForm dimensions */
          .login-form-wrapper {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .login-form-wrapper::before {
            content: "";
            position: absolute;
            inset: -12px;
            border-radius: 24px;

            background: linear-gradient(
              135deg,
              rgba(6, 59, 135, 0.08),
              rgba(10, 87, 187, 0.04),
              rgba(8, 115, 68, 0.06)
            );

            filter: blur(12px);
            z-index: -1;
          }

          /* Waves */
          .login-waves {
            height: 260px;
            z-index: 5;
            pointer-events: none;
          }

          .login-waves svg {
            display: block;
            width: 100%;
            height: 260px;
          }

          /* Mobile */
          @media (max-width: 768px) {
            .login-glow {
              width: 240px;
              height: 240px;
              filter: blur(65px);
            }

            .login-waves {
              height: 180px;
            }

            .login-waves svg {
              height: 180px;
            }

            .login-brand {
              font-size: 10px;
              letter-spacing: 2.5px;
            }

            .brand-line {
              width: 22px;
            }
          }

          @media (max-width: 576px) {
            .login-waves {
              height: 130px;
            }

            .login-waves svg {
              height: 130px;
            }

            .login-brand {
              margin-bottom: 8px !important;
            }

            .login-form-wrapper::before {
              inset: -6px;
            }
          }

          @media (prefers-reduced-motion: no-preference) {
            .login-glow-left {
              animation: glowLeft 7s ease-in-out infinite alternate;
            }

            .login-glow-right {
              animation: glowRight 8s ease-in-out infinite alternate;
            }
          }

          @keyframes glowLeft {
            from {
              transform: translate(0, 0);
            }

            to {
              transform: translate(25px, 20px);
            }
          }

          @keyframes glowRight {
            from {
              transform: translate(0, 0);
            }

            to {
              transform: translate(-20px, 25px);
            }
          }
        `}
      </style>
    </div>
  );
};

export default LoginHome;
